import { Component } from '@angular/core';

import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  templateUrl: './s-form-pdf-preview-dialog.component.html',
  styleUrls: ['./s-form-pdf-preview-dialog.component.css'],
  standalone: true,
  imports: [NgxExtendedPdfViewerModule]
})
export class SFormPdfPreviewDialogComponent {
  constructor(
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {
    pdfDefaultOptions.assetsFolder = 'https://cdn.jsdelivr.net/npm/ngx-extended-pdf-viewer@25.6.4/assets';
    //console.log('Dialog config', dialogConfig);
  }
  onEvent(_event: string, _data: any) {
    //console.log(event, data);
  }
}
